import { caching } from '@/common/cache.dict.js';
import { boundApiRequest } from '@/restapi/restapi.base.js';


const doRequest = boundApiRequest('/api/feedback/');


async function _getThemes() {
    const { result } = await doRequest('themes', {});
    return result;
}

export const getThemes = caching(_getThemes);

export async function load(id) {
    const { result } = await doRequest('load', { id });
    return result;
}

export async function save(data) {
    const { result } = await doRequest('save', data, { blocking: true });
    return result;
}

export async function search(reqt) {
    const { result } = await doRequest('search', reqt, {});

    return result;
}

export async function setStatus(data) {
    const { result } = await doRequest('setStatus', data, { blocking: true });
    return result;
}

export async function setResponsibleUser(id) {
    const { result } = await doRequest('setResponsibleUser', {
        id,
    }, { blocking: true });
    return result;
}

export async function sendFeedback(data) {
    const form = new FormData();

    for (const doc of data.documents) {
        form.append('files', new File([ doc.file ], doc.name));
    }

    delete data.documents;
    form.set('json', JSON.stringify({ ...data }));

    const { result } = await doRequest('send', form);
    return result;
}

async function _getDefaultResponsibleUser() {
    const { result } = await doRequest('defaultResponsibleUser', {});
    return result;
}

export const getDefaultResponsibleUser = caching(_getDefaultResponsibleUser);
